import type { Transport } from "mediasoup-client/types";
import { socket } from "./socket";
import { getDevice } from "./device";

export async function createRecvTransport(): Promise<Transport> {
  return new Promise((resolve) => {
    socket.emit("create-transport", { direction: "recv" }, (params: any) => {
      const transport = getDevice().createRecvTransport(params);

      transport.on("connect", ({ dtlsParameters }, cb) => {
        socket.emit(
          "connect-transport",
          { direction: "recv", dtlsParameters },
          cb,
        );
      });

      resolve(transport);
    });
  });
}
